import { postRequest } from '@/core';
import { locations } from '@/requests';

export default async function getExpandPointRequest(geometry, radius) {
	let url = locations.getExpandPointPath();
	try {
		let response = await postRequest(url, {}, { geometry, radius });
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}
